window.addEventListener('load', ()=>{


const allNodesCarousel = document.querySelectorAll('.slider-section');


allNodesCarousel.forEach(carousel => {

    const carouselItem = carousel.querySelector('.slider-section-item');
    const nextButton = carousel.querySelector('.next-button-slide');
    const prevButton = carousel.querySelector('.prev-button-slide');
    
    $(carouselItem).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows:false,
        autoplay:true,
        autoplaySpeed:7000,
        pauseOnHover:true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
           
          ]
    });
    $(nextButton).click(function(){
        $(carouselItem).slick('slickNext');
    });
    $(prevButton).click(function(){
        $(carouselItem).slick('slickPrev');
    });
});
})

